<template>
    <v-app>
        <v-container class="fill-height">
            <v-row justify="center">
                <v-col cols="4" class="text-center">
                    <v-progress-circular
                        v-if="status == 'loading'"
                        indeterminate
                        color="primary"
                        size="80"
                    ></v-progress-circular>

                    <template v-else-if="status == 'notfound'">
                        Link yang kamu punya tidak valid

                        <home-button></home-button>
                    </template>

                    <template v-else-if="status == 'error'">
                        Terjadi kesalahan, coba lagi nanti<br>
                        {{ error }}
                        <home-button></home-button>
                    </template>

                    <div v-if="link" class="mt-4">
                        {{ link.title }}
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import HomeButton from './components/HomeButton.vue'

export default {
    components: {
        HomeButton,
    },

    data: () => ({
        link: null,
        status: 'loading',
        error: null,
    }),

    methods: {
        redirect() {
            setTimeout(() => window.location.href = this.link.url, 500)
        }
    },

    async created() {
        try {
            const response = await this.$apiv2.get(`link/${this.$route.params.link}`)

            this.link = response.data

            const authResponse = await this.$api.get('auth', { noAuthErrorRedirect: true })
            this.$store.dispatch('auth/setDataFromAuth', authResponse.data)
            this.redirect()
        } catch (e) {
            if (e?.response?.status == 404) {
                this.status = 'notfound'
            } else if (e?.response?.status == 401) {
                this.redirect()
            } else {
                this.status = 'error'
                this.error = e
            }
        }
    }
}
</script>
